import { render, staticRenderFns } from "./ServiceCodeBadges.vue?vue&type=template&id=95ee39ec&scoped=true&"
import script from "./ServiceCodeBadges.vue?vue&type=script&lang=js&"
export * from "./ServiceCodeBadges.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCodeBadges.vue?vue&type=style&index=0&id=95ee39ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee39ec",
  null
  
)

component.options.__file = "ServiceCodeBadges.vue"
export default component.exports